import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { CommuneEntity } from '@/utils/geo-search'

export type Store = {
  locality: CommuneEntity | null,
  type: 'sell' | 'rent' | null,
  setLocality: (locality: CommuneEntity | null) => void,
  setType: (type: 'sell' | 'rent' | null) => void
}

export const useEstimateFormStore = create<Store>()(
  persist(
    (set) => ({
      locality: null,
      setLocality: (locality: CommuneEntity | null) => set(() => ({ locality })),
      type: 'sell', 
      setType: (type: 'sell' | 'rent' | null) => set(() => ({ type })),
    }),
    {
      name: 'estimate-form', // name of the item in the storage (must be unique)
    },
  )
)